import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class CustomerCreditDto extends DtoDetail{

    public customerDtoId : number;
    public customerDtoName : string;
    public creditAmount: number;
    public currency: string;

}